import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  AuthConfig,
  authConfig,
  AuthDataAccessModule,
} from '@cigna/shared/angular/auth-data-access';

import {
  Auth0FlowConfig,
  auth0FlowConfig,
  Auth0FlowService,
} from '@cigna/shared/angular/auth/oidc-util/auth0';
import { ChcpAuthenticationService } from './auth/authentication.service';
@NgModule({
  imports: [CommonModule, AuthDataAccessModule],
})
export class ChcpAuthDataAccessModule {
  static withAuth0Config(
    config: ChcpAuthConfig,
    // publicUris: string[],
  ): ModuleWithProviders<ChcpAuthDataAccessModule> {
    return {
      ngModule: ChcpAuthDataAccessModule,
      providers: [
        auth0FlowConfig(config),
        authConfig({
          authenticator: Auth0FlowService,
          errorHandler: ChcpAuthenticationService,
          secureUris: config.secureUris,
          // publicUris: [...(config.publicUris || []), ...publicUris],
          publicUris: config.publicUris,
          noRefreshUris: config.noRefreshUris,
          loadBehavior: 'onDemand',
        }),
      ],
    };
  }
}

export type ChcpAuthConfig = Pick<
  AuthConfig,
  'secureUris' | 'publicUris' | 'noRefreshUris'
> &
  Auth0FlowConfig;
